var Base = require('_js/base'),
  ko = require('knockout');

var model = function(params) {
  this.params = params;
};

function FindAccountantsModule() {
  this.init();
}

FindAccountantsModule.prototype = new Base();

FindAccountantsModule.prototype.init = function() {
  var $findAccountants = $('[data-find-accountants]');
  if ($findAccountants.get(0) !== undefined) {
    ko.applyBindings(new model({}), $findAccountants.get(0));
  }
};

module.exports = FindAccountantsModule;
